import Label from 'components/Label'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React from 'react'
import { TeenagerType } from 'types/teenager-record.type'
import { formatBirthdayEN, formatText } from 'utils/text.util'
import dayjs from 'dayjs'
import { Box } from '@mui/material'

type UserInfoProps = {
  data: TeenagerType
}

export const UserInfo: React.FC<UserInfoProps> = ({ data }) => {
  return (
    <>
      {data.identAdolescente.nomeSocial && (
        <Label
          text={formatText(data.identAdolescente.nomeSocial)}
          v='h4'
          color='primary'
          bold
          sx={{ textAlign: 'center' }}
        />
      )}
      <Label
        text={formatText(data.identAdolescente.nome)}
        v='h6'
        color='primary'
        bold
        sx={{ textAlign: 'center' }}
      />
      <Field
        label='Data de nascimento'
        value={[formatBirthdayEN(data.identAdolescente.dataNascimento)]}
        direction='column'
      />
      <Field
        label='Gênero'
        value={[formatText(data.identAdolescente.descricaoIdGenero)]}
        direction='column'
      />
      <Field
        label='Raça/Cor'
        value={[formatText(data.identAdolescente.descricaoIdRaca)]}
        direction='column'
      />
      <Field
        label='Nome do pai'
        value={[formatText(data.identAdolescente.nomePai)]}
        direction='column'
      />
      <Field
        label='Nome da mãe'
        value={[formatText(data.identAdolescente.nomeMae)]}
        direction='column'
      />

      <Box
        sx={{
          paddingTop: '1.25rem',
        }}
      >
        <Field
          label='Data da última atualização'
          value={[dayjs(data.identAdolescente.ultimaAtualizacao).format('DD/MM/YYYY HH:mm') || '']}
          variant={'body2'}
          direction='column'
        />
      </Box>
    </>
  )
}
